import StarShapeComponent from "./star-shape-component";
import StarShapeConfig from "./star-shape-config";
import StarShapeAdvancedConfig from "./star-shape-advanced-config";

export default {
  StarShapeComponent,
  StarShapeConfig,
  StarShapeAdvancedConfig
};
